import { forwardRef } from 'react';
import { useFilterModulesStore } from 'components/filter/filters-next/filterModules';
import { RelationalServerKey, ServerKey } from 'components/filter/types';

interface LabelStrategyProps {
    strategy: ServerKey;
    relationalServerKey?: RelationalServerKey;
}

const LabelStrategy = forwardRef<HTMLElement, LabelStrategyProps>(
    ({ strategy, relationalServerKey }, ref) => {
        const filterModules = useFilterModulesStore(state => state.modules);
        const Label = filterModules[strategy].Label;

        return (
            <span ref={ref}>
                <Label strategyType={strategy} relationalServerKey={relationalServerKey} />
            </span>
        );
    },
);

export { LabelStrategy };
